import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoStaff4attendancesGetRes } from "./abst/DtoStaff4attendancesGetRes";
import { EntityStaff } from "../entity/EntityStaff";

export class DtoStaff4attendancesGetResImple extends DtoStaff4attendancesGetRes {
  /**
   * 出向フラグがONの社員
   */
  public item4onLoanStaffs: EntityStaff[] = [];

  public pager = new DtoApiPager();
}
